import { device as deviceUtils } from '@seek/ca-myprofile-utils';
import clsx from 'clsx';

import * as styles from './Tick.css';

interface Props {
  className?: string;
  svgClassName?: string;
}

export const Tick = ({
  className = '',
  svgClassName = '',
  ...restProps
}: Props) => {
  const svgStyles = clsx({
    [styles.svg]: true,
    [svgClassName]: svgClassName,
  });

  const combinedProps = {
    ...restProps,
    className: clsx(styles.root, className),
  };

  return (
    <span {...combinedProps}>
      <svg
        className={svgStyles}
        xmlns="http://www.w3.org/2000/svg"
        width="15"
        height="11"
        viewBox="0 0 15 11"
      >
        <path
          className={!deviceUtils.isMicrosoft() ? styles.pathAnimation : ''}
          strokeWidth="1.5"
          strokeLinecap="square"
          strokeMiterlimit="10"
          d="M1.46 6.083l3.64 3.64 8.44-8.443"
        />
      </svg>
    </span>
  );
};
